{
  "nl": {
    "ticket": {
      "actions": {
        "assignCustomer": "Voltooi toekenning",
        "bulk_assign_new_emp": "Nieuwe verantwoordelijke in bulk toewijzen",
        "close": "Sluiten",
        "create_new": "Nieuw gesprek maken",
        "customer_new_ticket": "Nieuw gesprek",
        "delete": "Verwijder",
        "edit": "Bewerk",
        "existing_conversation": "Bestaand gesprek",
        "goToConversation": "Ga naar gesprek",
        "move_to_existing": "Verplaats bericht naar bestaand gesprek",
        "new": "Gesprek",
        "new_aria_label": "Een nieuw gesprek beginnen",
        "new_conversation": "Nieuw gesprek",
        "reopen": "Heropenen",
        "selectResponsible": "Selecteer Verantwoordelijke",
        "selectUnit": "Selecteer Unit",
        "show": "Toon",
        "startNew": "Een nieuw gesprek starten"
      },
      "attributes": {
        "status": "Status",
        "statuses": {
          "closed": "Gesloten",
          "feedback": "Feedback afwachten",
          "ongoing": "In behandeling",
          "open": "Open"
        },
        "title": "Titel"
      },
      "editor": {
        "tooltips": {
          "bold": "Vet",
          "bulletList": "Bulletlist",
          "highlight": "Markeer",
          "italic": "Cursief",
          "link": "Link",
          "orderedList": "Genummerde lijst",
          "redo": "Opnieuw doen",
          "strike": "Doorhalen",
          "textColor": "Tekstkleur",
          "underline": "Onderstrepen",
          "undo": "Ongedaan maken",
          "unlink": "Ontkoppelen"
        }
      },
      "labels": {
        "addFile": "Bestand toevoegen",
        "additionalQuestion": "Heb je nog een vraag?",
        "all": "Alle",
        "allProjects": "Alle projecten",
        "allUnits": "Alle units",
        "assign_conversations": "Gesprekken toewijzen van",
        "bulk_assign_new_emp_warning": "Deze update omvat ook gesprekken die verband houden met beslissingen of nazorg. Voor gerelateerde beslissingen (van deze betrokken gesprekken) wordt de verantwoordelijke medewerker ook bijgewerkt.",
        "cantChangeResponsibleAftercare": "Dit gesprek is gekoppeld aan een nazorg ticket. Wijzig de verantwoordelijke daar.",
        "cantChangeResponsibleDecision": "Dit gesprek is gekoppeld aan een beslissing. Wijzig de verantwoordelijke daar.",
        "cantDelete": "Dit gesprek hoort bij een beslissing en kan niet worden verwijderd.",
        "cantEdit": "Deze conversatie hoort bij een beslissing. Bewerk het vanuit de beslissing",
        "changeResponsible": "Wijzig",
        "change_responsible": "Verander verantwoordelijke voor gesprekken",
        "clientWillRespondSoon": "Wij behandelen uw vraag zo snel mogelijk",
        "contact": "Contactpersoon",
        "contactPerson": "Jouw contactpersoon",
        "contactPersonWithName": "Jouw {name} contact",
        "conversation_title": "Gesprekstitel",
        "conversations": "Gesprekken",
        "create_ticket": "Maak een gesprek",
        "customer": "Klant",
        "customers": "Klanten",
        "decision": "Welke beslissing?",
        "decisionConversation": "Beslissing",
        "decisionConversations": "Beslissingen",
        "disabled_unit": "Deze unit is gedeactiveerd. Er kunnen geen berichten worden verzonden.",
        "documentAddedBy": "van",
        "documents": "Documenten",
        "email_forwarding": "E-mail forwarding",
        "employee": "Teamlid",
        "export_conversation": "Exporteer gesprek",
        "files": "Bestanden",
        "filter": "Filteren",
        "inbound_by": "Inkomend van {name}",
        "inbound_emails": "Inkomende e-mails",
        "info": "Een vraag en je vond geen antwoord in de {faq_route} sectie? Stel ze hier! Gelieve jouw vragen te bundelen in duidelijke onderwerpen, zoals 'Lastenboek'.",
        "keywords": "Zoek op inhoud",
        "lastMessage": "Laatste bericht",
        "message": "Bericht",
        "message_placeholder": "Schrijf je bericht hier...",
        "message_subtitle": "Beschrijf je vraag of probleem",
        "messaged_at_nulls_first_asc": "Oudste activiteit",
        "messaged_at_nulls_last_desc": "Laatste activiteit",
        "myProjects": "Mijn projecten",
        "myTickets": "Mijn gesprekken",
        "myTicketsTooltip": "Toon enkel gesprekken waar je de verantwoordelijke bent",
        "name_lower_asc": "Titel A -> Z",
        "name_lower_desc": "Titel Z -> A",
        "newConversation": "Nieuw Gesprek",
        "newMessage": "Nieuw Bericht",
        "newMessages": "Nieuwe berichten",
        "newWithPartner": "Ziggu en {partner}",
        "newWithZiggu": "Alleen Ziggu",
        "noCustomer": "Geen klant toegekend of uitgenodigd op dit moment",
        "noCustomerAssignedToUnit": "Geen klant toegewezen aan deze unit. Wil je verder gaan?",
        "noCustomerAssignedToUnitExplainer": "Let op, je zal dus nog een ontvanger moeten selecteren.",
        "noCustomerAssignedToUnit_SUP": "Er is geen klant toegewezen aan dit project. Wilt u doorgaan?",
        "noCustomerInvited": "De klant die is toegewezen aan deze unit is nog niet uitgenodigd. Wil je verder gaan?",
        "noFiles": "Nog geen bestanden geüpload",
        "noMessagesYet": "Nog geen berichten",
        "noTickets": "Geen gesprekken",
        "no_messages": "Gesprek is leeg",
        "notSeenYet": "Nog niet gezien",
        "notYetDetermined": "Nog niet bepaald",
        "note": "Notitie",
        "note_placeholder": "Schrijf enkel naar teamleden. Typ {'@'} om een teamlid te taggen zodat deze op de hoogte wordt gebracht.",
        "onlySelect": "Toon enkel",
        "orNewTicket": "Of open een nieuwe over een ander onderwerp",
        "otherTickets": "Andere klantgesprekken",
        "participants": "1 lid | {count} leden",
        "partner": "Partner",
        "partnerGroup": "Met wie wil je praten?",
        "partnersDecision": "Beslissingspartners",
        "pendingContactPerson": "Jouw contactpersoon zal zo snel mogelijk antwoorden",
        "pendingTickets": "Nieuwe berichten",
        "project": "Project",
        "read": "Gelezen",
        "remove_inbound_email": "{email} verwijderen?",
        "reply": "Antwoord",
        "reply_placeholder": "Schrijf naar iedereen",
        "responsible": "Verantwoordelijke",
        "search": "Zoek",
        "search_conversation": "Zoek",
        "seen": "Gezien",
        "seenAll": "Alle",
        "seenBy": "Gezien door {name}",
        "selectLevel": "Selecteer niveau",
        "selectUnit": "Selecteer unit",
        "show": "Toon",
        "showFiles": "Bestanden tonen",
        "showTicketsFor": "Toon gesprekken voor",
        "showingAll": "Alle gesprekken",
        "sort": "Sorteer op",
        "startConversation": "Start een nieuw gesprek",
        "startConversationForProject": "Start een nieuw gesprek in project ",
        "startNewConversation": "Start een nieuw gesprek",
        "subject": "Onderwerp",
        "subject_subtitle": "Beschrijf in een paar woorden",
        "teamMember": "Teamlid",
        "ticketClosed": "Dit gesprek is voltooid en gesloten.",
        "ticketClosedByResponsible": "Dit gesprek is gesloten door {responsible}",
        "ticketClosedCustomer": "Heb je nog een vraag? Gelieve een nieuw gesprek te starten.",
        "ticketClosedEmployee": "Wil je het gesprek opnieuw openen, verander dan de status bovenaan.",
        "ticket_category": "Categorie",
        "tickets_all_projects": "Gesprekken alle projecten",
        "to": "naar",
        "unit": "Unit",
        "unit_name_lower_asc": "Unit A -> Z",
        "unit_name_lower_desc": "Unit Z -> A",
        "unread": "Ongelezen",
        "upload_files": "1 bestand in behandeling | {count} bestanden in behandeling",
        "warning_move_message_to_new_ticket": "Dit bericht wordt verplaatst naar een gewoon gesprek, dat niet gekoppeld zal zijn aan een beslissing of probleem.",
        "withMentions": "Vermeld in",
        "withMessages": "Met berichten",
        "writeMessageToBecomeResponsible": "Schrijf een bericht om verantwoordelijk te worden",
        "you": "jij"
      },
      "messages": {
        "redirect_decision": "Dit gesprek maakt deel uit van een beslissing. Klik hier om de beslissing te bekijken.",
        "redirect_issue": "Dit gesprek maakt deel uit van Nazorg. Klik hier om naar Nazorg te gaan.",
        "redirect_link": "Details bekijken"
      },
      "navigation": {
        "backToTickets": "Ga terug"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Probeer jouw vragen te groeperen in algemene gespreksonderwerpen, bvb. 'Lastenboek'.",
            "title": "Een vraag? Stel ze hier!"
          },
          "none": {
            "title": "Geen gesprekken gevonden"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Begin je eerste gesprek met iemand!",
            "title": "Heb je een vraag?"
          },
          "none": {
            "subtitle": "Pas de filters aan bovenaan de pagina voor het zoeken naar relevante gesprekken.",
            "subtitle_aftercare": "Klik op de 3 stippen van een punt om een gesprek te beginnen",
            "title": "Geen gesprekken gevonden"
          }
        }
      },
      "toasts": {
        "responsible_updated": "Verantwoordelijke succesvol geüpdatet!"
      },
      "validation": {
        "mustBeMaximum": "Mag maximum een lengte van {number} letters hebben.",
        "needCustomer": "Selecteer een klant",
        "needMessage": "Bericht vereist",
        "needName": "Titel vereist",
        "needResponsible": "Selecteer een verantwoordelijke",
        "needSubject": "Onderwerp vereist",
        "needUnit": "Selecteer een unit"
      }
    }
  }
}
